/* TODO: something that needs to find its place in the world */
export default {
 test_id: {
  speed_test: 164
 },
};
